var alignment_rtlignore_default = {
  "alignLeft": "xGBOo",
  "textWrapNowrap": "E-KBn",
  "alignRight": "JEMbn",
  "alignCenter": "nHjzp",
  "sizeFullWidth": "RqrCV",
  "renderedInTable": "aiR98",
  "sizeOriginal": "Jh4s-",
  "sizeContent": "_8L7O7",
  "sizeSmall": "GAEnk",
  "sizeSmallCenter": "BHIID",
  "flex": "nEDf3",
  "LEFT": "YP2cN",
  "CENTER": "_3S9Yh",
  "RIGHT": "pzy5R",
  "AUTO": "O-lA1",
  "JUSTIFY": "RAy5f"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
